// Mock data for restaurant landing page

export const restaurantInfo = {
  name: "Mr. Crunch 28",
  tagline: "El sabor que conquista",
  slogan: "¡Crujiente por fuera, irresistible por dentro!",
  description: "Descubre la combinación perfecta entre el crujiente pollo frito y las hamburguesas más jugosas de la ciudad. Servicio a domicilio disponible.",
  phone: "877 177 8264",
  email: "mrcrunch2friedchicken@gmail.com",
  address: "Calle Luis G. Urbina #1490, Colonia 28 de Junio",
  city: "Cd. Acuña, Coahuila, México",
  hours: "Jue-Vie: 5:00 PM - 10:00 PM | Sáb-Dom: 12:00 PM - 10:00 PM",
  socialMedia: {
    facebook: "https://www.facebook.com/share/17Guwwc5NV/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/mrcrunchfriedchicken",
    whatsapp: "https://wa.me/528771228589"
  }
};

// Menú organizado por categorías
export const menuCategories = [
  {
    id: "pollo-frito",
    name: "Pollo Frito",
    description: "Incluye papas, pan y jalapeño",
    items: [
      { id: 1, name: "Pollo Frito #1", price: 65, description: "1 pieza de pollo frito crujiente" },
      { id: 2, name: "Pollo Frito #2", price: 115, description: "2 piezas de pollo frito crujiente" },
      { id: 3, name: "Pollo Frito #3", price: 160, description: "3 piezas de pollo frito crujiente" },
      { id: 4, name: "Pollo Frito #4", price: 200, description: "4 piezas de pollo frito crujiente" },
      { id: 5, name: "Pollo Frito #5", price: 250, description: "5 piezas de pollo frito crujiente" },
      { id: 6, name: "Pollo Frito #6", price: 300, description: "6 piezas de pollo frito crujiente" },
      { id: 7, name: "Pollo Frito #7", price: 360, description: "7 piezas de pollo frito crujiente" },
      { id: 8, name: "Pollo Frito #8", price: 400, description: "8 piezas de pollo frito crujiente" },
      { id: 9, name: "Pollo Frito #9", price: 450, description: "9 piezas de pollo frito crujiente" },
      { id: 10, name: "Pollo Frito #10", price: 500, description: "10 piezas de pollo frito crujiente" },
      { id: 11, name: "Pechuga Natural", price: 125, description: "Pechuga de pollo natural a la plancha" },
      { id: 12, name: "Pechuga Rellena", price: 150, description: "Deliciosa pechuga de pollo rellena" },
      { id: 13, name: "Ensalada Spicy", price: 140, description: "Ensalada fresca con toque picante" }
    ]
  },
  {
    id: "hamburguesas-res",
    name: "Hamburguesas 100% Res",
    description: "Todas incluyen papas y jalapeño",
    items: [
      { 
        id: 14, 
        name: "Hamburguesa Tradicional", 
        price: 120, 
        description: "130g de carne, aguacate, jamón, queso blanco, tomate, cebolla, aderezo de la casa" 
      },
      { 
        id: 141, 
        name: "Hamburguesa Tradicional Doble", 
        price: 145, 
        description: "Doble carne (260g), aguacate, jamón, queso blanco, tomate, cebolla, aderezo de la casa" 
      },
      { 
        id: 15, 
        name: "Hamburguesa Americana", 
        price: 130, 
        description: "130g de carne, tocino, pepinillos, jalapeños, queso amarillo, tomate, lechuga, cebolla, aderezo de la casa" 
      },
      { 
        id: 151, 
        name: "Hamburguesa Americana Doble", 
        price: 155, 
        description: "Doble carne (260g), tocino, pepinillos, jalapeños, queso amarillo, tomate, lechuga, cebolla, aderezo de la casa" 
      },
      { 
        id: 16, 
        name: "Hamburguesa CBT", 
        price: 130, 
        description: "130g de carne, aros de cebolla empanizada, salsa BBQ, tocino, queso amarillo, tomate, pepinillos, aderezo de la casa" 
      },
      { 
        id: 161, 
        name: "Hamburguesa CBT Doble", 
        price: 155, 
        description: "Doble carne (260g), aros de cebolla empanizada, salsa BBQ, tocino, queso amarillo, tomate, pepinillos, aderezo de la casa" 
      },
      { 
        id: 17, 
        name: "Jr Cheeseburger", 
        price: 80, 
        description: "90g de carne, queso americano, cebolla, pepinillos, aderezo de la casa" 
      },
      { 
        id: 171, 
        name: "Jr Cheeseburger Doble Carne", 
        price: 100, 
        description: "Doble carne (180g), queso americano, cebolla, pepinillos, aderezo de la casa" 
      }
    ]
  },
  {
    id: "hamburguesas-pechuga",
    name: "Hamburguesas de Pechuga",
    description: "Todas incluyen papas y jalapeño",
    items: [
      { id: 18, name: "Mr. Crunch", price: 130, description: "Pechuga empanizada crujiente estilo signature" },
      { id: 19, name: "Búfalo", price: 150, description: "Pechuga con salsa búfalo picante" },
      { id: 20, name: "BBQ", price: 150, description: "Pechuga con salsa BBQ ahumada" },
      { id: 21, name: "A la Plancha", price: 140, description: "Pechuga natural a la plancha" },
      { id: 22, name: "Habanero", price: 160, description: "Pechuga con salsa habanero extra picante" },
      { id: 23, name: "Chipotle", price: 160, description: "Pechuga con salsa chipotle ahumada" },
      { id: 24, name: "Mr. Spicy", price: 170, description: "La más picante! Pechuga con nuestra salsa especial" }
    ]
  },
  {
    id: "fajitas",
    name: "Fajitas de Pollo",
    description: "Frescas y jugosas",
    items: [
      { id: 25, name: "Fajita Individual Natural", price: 150, description: "Porción individual de fajita natural" },
      { id: 26, name: "Fajita 1/2 Kilo Natural", price: 230, description: "Medio kilo de fajita natural" },
      { id: 27, name: "Fajita 1 Kilo Natural", price: 350, description: "Un kilo completo de fajita natural" },
      { id: 28, name: "Fajita Individual Spicy", price: 160, description: "Porción individual de fajita picante" },
      { id: 29, name: "Fajita 1/2 Kilo Spicy", price: 260, description: "Medio kilo de fajita picante" },
      { id: 30, name: "Fajita 1 Kilo Spicy", price: 380, description: "Un kilo completo de fajita picante" }
    ]
  },
  {
    id: "combos",
    name: "Combos",
    description: "Combos completos para disfrutar",
    items: [
      { id: 31, name: "Combo 1", price: 95, description: "1 pieza de pollo, burrito, cebolla empanizada, papas, pan y jalapeño" },
      { id: 32, name: "Combo 2", price: 110, description: "1 pieza de pollo, burrito, cola americana, papas, pan y jalapeño" },
      { id: 33, name: "Combo 3", price: 130, description: "2 piezas de pollo, cola americana, papas, pan y jalapeño" },
      { id: 34, name: "Combo 4", price: 70, description: "2 burritos con papas, cola americana y jalapeño" },
      { id: 35, name: "Combo 5", price: 270, description: "2 hamburguesas Mr. Crunch, refrescos cola americana, con papas" },
      { id: 36, name: "Combo 6", price: 130, description: "2 hamburguesas Jr. Cheeseburger con papas" },
      { id: 37, name: "Combo 7", price: 250, description: "2 hamburguesas Tradicionales, 2 refrescos cola americana y papas" },
      { id: 38, name: "Combo 8", price: 300, description: "1 hamburguesa Chipotle, 1 hamburguesa Habanero, 2 refrescos, 1 porción de ranch, con papas sazonadas" }
    ]
  },
  {
    id: "complementos",
    name: "Complementos",
    description: "Acompaña tu orden con estos deliciosos complementos",
    items: [
      { id: 39, name: "Papas Naturales", price: 50, description: "Porción de papas naturales" },
      { id: 40, name: "Papas con Queso", price: 65, description: "Papas naturales con queso derretido" },
      { id: 41, name: "Papas Empanizadas", price: 70, description: "Papas crujientes empanizadas" },
      { id: 42, name: "Papas Empanizadas con Queso", price: 85, description: "Papas empanizadas con queso derretido" },
      { id: 43, name: "Papas Sazonadas de Gajo", price: 70, description: "Papas en gajo con sazonado especial" },
      { id: 44, name: "Burrito de Frijol", price: 30, description: "Burrito relleno de frijoles" },
      { id: 45, name: "Burrito de Pizza", price: 30, description: "Burrito estilo pizza" },
      { id: 46, name: "Pieza de Jalapeño", price: 4, description: "Jalapeño fresco por pieza" },
      { id: 47, name: "Pieza de Pan", price: 4, description: "Pan fresco por pieza" },
      { id: 48, name: "Orden de Cebolla Empanizada", price: 55, description: "Aros de cebolla empanizados crujientes" }
    ]
  },
  {
    id: "aderezos",
    name: "Aderezos",
    description: "Salsas y aderezos para complementar tu comida",
    items: [
      { id: 49, name: "Porción de Queso", price: 25, description: "Aderezo de queso" },
      { id: 50, name: "Porción de Ranch", price: 25, description: "Aderezo ranch clásico" },
      { id: 51, name: "Porción de Búfalo", price: 25, description: "Salsa búfalo picante" },
      { id: 52, name: "Porción de BBQ", price: 25, description: "Salsa BBQ ahumada" },
      { id: 53, name: "Porción de Habanero", price: 25, description: "Salsa habanero extra picante" },
      { id: 54, name: "Porción de Chipotle", price: 25, description: "Salsa chipotle ahumada" },
      { id: 55, name: "Porción de Ranch Especial", price: 30, description: "Aderezo ranch especial de la casa" }
    ]
  },
  {
    id: "refrescos",
    name: "Refrescos",
    description: "Bebidas frías para acompañar",
    items: [
      { id: 56, name: "Soda Americana", price: 15, description: "Refresco americano clásico" },
      { id: 57, name: "Coca Cola", price: 25, description: "Coca Cola en lata" },
      { id: 58, name: "Big Red", price: 25, description: "Big Red en lata" },
      { id: 59, name: "Dr Pepper", price: 25, description: "Dr Pepper en lata" },
      { id: 60, name: "Sprite", price: 25, description: "Sprite en lata" },
      { id: 61, name: "Soda de Raíz", price: 25, description: "Soda de raíz en lata" }
    ]
  }
];

// Mantenemos menuItems para compatibilidad con el carrito
export const menuItems = menuCategories.flatMap(category => 
  category.items.map(item => ({
    ...item,
    category: category.id,
    image: category.id.includes('pollo') || category.id === 'fajitas'
      ? "https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxmcmllZCUyMGNoaWNrZW58ZW58MHx8fHwxNzY1NDc1NjMyfDA&ixlib=rb-4.1.0&q=85"
      : "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxidXJnZXJ8ZW58MHx8fHwxNzY1NDc1NjM3fDA&ixlib=rb-4.1.0&q=85"
  }))
);

export const aboutInfo = {
  title: "Nuestra Historia",
  story: "Desde 2015, hemos sido el destino favorito para los amantes del buen pollo frito y hamburguesas gourmet. Nuestra pasión es servir comida de calidad premium con ingredientes frescos y recetas que han pasado de generación en generación.",
  values: [
    {
      icon: "🔥",
      title: "Frescura Garantizada",
      description: "Ingredientes frescos todos los días"
    },
    {
      icon: "⭐",
      title: "Calidad Premium",
      description: "Solo usamos los mejores cortes"
    },
    {
      icon: "🚚",
      title: "Entrega Rápida",
      description: "Tu comida caliente en 30 minutos"
    }
  ]
};

// Mock cart state
export const mockCart = [];

// Mock function to simulate order submission
export const submitOrder = (orderData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, orderId: Math.random().toString(36).substr(2, 9) });
    }, 1000);
  });
};

// Mock function to simulate contact form submission
export const submitContact = (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true });
    }, 1000);
  });
};